import { render, staticRenderFns } from "./verifySeckill.vue?vue&type=template&id=7f70e7b6&scoped=true"
import script from "./verifySeckill.vue?vue&type=script&lang=js"
export * from "./verifySeckill.vue?vue&type=script&lang=js"
import style0 from "./verifySeckill.vue?vue&type=style&index=0&id=7f70e7b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f70e7b6",
  null
  
)

export default component.exports